import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-family: 'Roboto', sans-serif;
  font-size: 42px;
  font-style: italic;
  font-weight: 900;
`;
Container.displayName = 'Container';

export const DataContainer = styled.div`
  align-items: flex-end;
  display: flex;
  height: 71px;
`;
DataContainer.displayName = 'DataContainer';

export const Image = styled.img`
  height: 68px;
  left: -34px;
  position: absolute;
  top: -60px;
  z-index: 2;
`;
Image.displayName = 'Image';

export const ImageAway = styled(Image)`
  left: -25px;
`;
ImageAway.displayName = 'ImageAway';

export const ImageContainer = styled.div`
  position: relative;
`;
ImageContainer.displayName = 'ImageContainer';

export const Logo = styled.img`
  margin-top: 5px;
`;
Logo.displayName = 'Logo';

export const Points = styled.div`
  font-size: 68px;
  font-style: normal;
  font-weight: 900;
  margin: 0px 6px 0 12px;
  min-width: 45px;
  text-align: center;
`;
Points.displayName = 'Points';

export const PointsAway = styled(Points)`
  margin: 0px 12px 0 6px;
`;
PointsAway.displayName = 'PointsAway';

export const PointsContainer = styled.div`
  align-items: center;
  background: #000000;
  color: #ffffff;
  display: flex;
  height: 71px;
  padding: 0 16px;
`;
PointsContainer.displayName = 'PointsContainer';

export const SpaceBar = styled.div`
  background: linear-gradient(90deg, #d0a664 0%, #e47433 49.48%, #d0a664 100%);
  height: 4px;
  width: 100%;
`;
SpaceBar.displayName = 'SpaceBar';

export const SpaceBarContainer = styled.div`
  display: flex;
  width: calc(100% - 40px);
`;
SpaceBarContainer.displayName = 'SpaceBarContainer';

export const TeamName = styled.span`
  background: #000000;
  color: #fff;
  font-style: italic;
  font-weight: 600;
  font-size: 46px;
  height: 55px;
  line-height: 56px;
  min-width: 135px;
  padding: 0 42px 0 8px;
  text-align: center;
`;
TeamName.displayName = 'TeamName';

export const TeamNameAway = styled(TeamName)`
  padding: 0 8px 0 42px;
`;
TeamName.displayName = 'TeamName';

export const TimerContainer = styled.div`
  align-items: center;
  display: flex;
  height: 43px;
  justify-content: center;
`;
TimerContainer.displayName = 'TimerContainer';

export const Timer = styled.span`
  background: #000000;
  color: #ffffff;
  font-size: 36px;
  font-style: italic;
  font-weight: 600;
  height: 43px;
  letter-spacing: 0.03em;
  line-height: 45px;
  text-align: center;
  width: 127px;
`;
Timer.displayName = 'Timer';
